import React, { useEffect, useState } from 'react';
import { Tab, Tabs } from 'react-bootstrap';
import { PublicNoticeTable } from './PublicNoticeTable';
import TopSearch from 'components/Auctions/TopSearchForm';
import useSearch from './hooks/useSearch';
import Pagination from 'components/partials/Pagination';
import { Loading } from 'components/Loading';
import MissingBlock from 'components/partials/MissingBlock';
import './styles.scss';
import { useService, requestCancelToken } from 'hooks/useService';
import { PublicNoticeAuction } from './types';
import { Canceler } from 'axios';

type TabType = 'active' | 'upcoming';

interface ServiceResponse {
    results: PublicNoticeAuction[];
    num_results: number;
}

const PublicNoticesSearchPage = () => {
    const [activeTab, setActiveTab] = useState<TabType>('active');
    const [
        {
            data: { results: auctions = [], num_results: total = 0 },
            loading: isLoading,
        },
        fireLoadAuctions,
    ] = useService<ServiceResponse>({
        url: 'public-notices',
    });
    const cancelCallbackRef = React.useRef<Canceler | null>(null);

    const { filters, onChangeFilters } = useSearch({
        searchFunction: async search_obj => {
            if (cancelCallbackRef.current) {
                cancelCallbackRef.current();
            }
            const { cancelToken, cancelCallback: requestCancel } = requestCancelToken();

            cancelCallbackRef.current = requestCancel;

            return fireLoadAuctions({
                params: { ...search_obj, status: activeTab },
                cancelToken,
            });
        },
    });

    const handleSearchChange = ({ target: { name, value } }) => {
        onChangeFilters({ [name]: value } as any, false);
    };

    const handleSearchSubmit = ({ search_obj }) => {
        onChangeFilters(search_obj, true);
    };

    useEffect(() => {
        onChangeFilters(
            {
                ...filters,
                page_num: 1,
                status: activeTab,
            },
            true,
        );
    }, [activeTab]);

    return (
        <div className="public-notice__search-page">
            <TopSearch
                search_obj={filters}
                search_obj_updated={handleSearchChange}
                redoSearch={handleSearchSubmit}
            />

            <Tabs
                activeKey={activeTab}
                onSelect={k => setActiveTab(k as TabType)}
            >
                <Tab
                    eventKey="active"
                    title="ACTIVE"
                    tabClassName="top-nav__tab w-50"
                />
                <Tab
                    eventKey="upcoming"
                    title="UPCOMING"
                    tabClassName="top-nav__tab w-50"
                />
            </Tabs>

            <div className="public-notice__list-container">
                {isLoading ? (
                    <Loading />
                ) : auctions && auctions.length > 0 ? (
                    <PublicNoticeTable auctions={auctions} />
                ) : (
                    <MissingBlock />
                )}
            </div>

            {total > 0 && (
                <Pagination
                    perPage={filters?.page_count}
                    dataCount={total}
                    currentPage={filters.page_num || 1}
                    redoSearch={(page_num: number) =>
                        handleSearchSubmit({
                            search_obj: { ...filters, page_num },
                        })
                    }
                />
            )}
        </div>
    );
};

export default PublicNoticesSearchPage;
